import Calendar from './Calendar';

export default Calendar;



// WEBPACK FOOTER //
// ./src/rc-calendar/index.js